import { Link } from "react-router-dom";

export function MarketingFooter() {
  return (
    <footer className="bg-card border-t border-border py-8 mt-auto">
      <div className="max-w-6xl mx-auto px-6">
        {/* Main grid — 2-col on mobile (brand spans both, links side-by-side), 4-col on desktop */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          <div className="col-span-2 md:col-span-2">
            <Link
              to="/"
              className="flex items-center gap-2.5 ds-title text-foreground mb-3"
            >
              <div className="w-7 h-7 rounded-lg bg-foreground flex items-center justify-center">
                <div className="w-2.5 h-2.5 rounded-sm bg-background" />
              </div>
              <span>
                Wiser<span className="text-primary">Studio</span>
              </span>
            </Link>
            <p className="ds-body-sm text-muted-foreground max-w-sm">
              The autonomous marketing team for B2B brands. AI-driven growth at scale.
            </p>
          </div>

          <div>
            <h4 className="ds-body-sm-strong text-foreground mb-3">Capabilities</h4>
            <ul className="space-y-2 ds-body-sm">
              <li>
                <Link
                  to="/capabilities/ad-cloning"
                  className="text-muted-foreground hover:text-primary transition-colors"
                >
                  Agentic Adclone
                </Link>
              </li>
              <li>
                <Link
                  to="/capabilities/campaign-management"
                  className="text-muted-foreground hover:text-primary transition-colors"
                >
                  Campaign Management
                </Link>
              </li>
              <li>
                <Link
                  to="/capabilities/creative-studio"
                  className="text-muted-foreground hover:text-primary transition-colors"
                >
                  Creative Studio
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="ds-body-sm-strong text-foreground mb-3">Company</h4>
            <ul className="space-y-2 ds-body-sm">
              <li>
                <Link
                  to="/privacy"
                  className="text-muted-foreground hover:text-primary transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="text-muted-foreground hover:text-primary transition-colors"
                >
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright — inline, tight */}
        <div className="mt-6 pt-4 border-t border-border">
          <p className="ds-caption text-muted-foreground text-center">
            &copy; {new Date().getFullYear()} WiserStudio. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
